import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

function EditorSkeleton() {
  return (
    <SkeletonTheme>
      <div className="flex items-center w-full p-2 justify-between">
        <div className="flex items-center gap-2">
          <Skeleton borderRadius={21} width={30} height={30} />
          <Skeleton borderRadius={21} width={100} height={30} />
        </div>
        <div className="flex items-center">
          <Skeleton borderRadius={21} width={100} height={30} />
        </div>
        <div className="flex items-center">
          <Skeleton borderRadius={21} width={300} height={30} />
        </div>
      </div>
      <div className="flex gap-2 w-full h-[90%] p-2">
        <div className="w-[5%] md:block hidden">
          <Skeleton borderRadius={21} className="w-full h-full" />
        </div>
        <div className="w-full ">
          <Skeleton borderRadius={21} className="w-full h-full" />
        </div>
      </div>
    </SkeletonTheme>
  );
}

export default EditorSkeleton;
